import React from "react";
import { Box, Paper } from "@mui/material";
import CustomText from "../CustomText";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const FeatureImageCard = ({
  icon,
  title,
  description,
  variant = "light", // 'light' or 'dark'
  sx,
}) => {
     const theme = useTheme();
  const isLight = variant === "light";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); 
  return (
    <Paper
      elevation={0}
      sx={{
        px: 3,
        py:1.8,
       
        border:"1px solid #636363",
        borderRadius: "10px",
        backgroundColor: isLight ? "white" : "#002A3F",
        // boxShadow: isLight
        //   ? "0px 4px 25px 0px rgba(141, 141, 141, 0.05)"
        //   : "0px 4px 25px 0px rgba(0, 0, 0, 0.05)",
        ...sx,
      }}
    >
      {/* <Box sx={{ mb: 3, mt:1,border:"1.8px solid #6B6D71",borderRadius:"10px",
         padding:"5px 6px 5px 6px",width:"26%"}}>{icon}</Box> */}
               <Box
           sx={{
             mb: 3,
             mt: 1,
           border:"1.8px solid #6B6D71",
             borderRadius: "10px",
             padding: "8px",
             width: isMobile ? "60px" : "60px", // fixed square width
             aspectRatio: "1 / 1",              // keeps it square
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
           }}
         >
           {icon}
         </Box>
      <CustomText
        customStyle={{
          fontSize: "19px",
          fontWeight: 600,
          fontFamily: "Poppins, sans-serif",
          color: isLight ? "#363333" : "white",
          textAlign: "left",
          marginBottom: "20px",
          lineHeight:"1.3"
        }}
      >
        {title}
      </CustomText>
      <CustomText
        style={{
          fontSize: "14px",
          fontWeight: 400,
          fontFamily: "Nunito, sans-serif",
          color: isLight ? "#868282" : "#E5E5E5",
          textAlign: "left",
          marginTop:"13px",
          lineHeight: "170%",
        }}
      >
        {description}
      </CustomText>
    </Paper>
  );
};

export default FeatureImageCard;